import { render } from "./ReviewsContentRank3.vue?vue&type=template&id=ec557636&scoped=true"
const script = {}

import "./ReviewsContentRank3.vue?vue&type=style&index=0&id=ec557636&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec557636"]])

export default __exports__